class BxfSelectConstants {
    static COMPONENT_NAME = 'bxf-select';
    static STRING = {
        CONTAINER: 'bxf-select__container',
        CONTAINER_LEFT_LABEL: 'bxf-select__container-left-label',
        CONTAINER_TIME_SCALE: 'bxf-select__container--time-scale',
        INPUT_WRAPPER: 'bxf-select__input-wrapper',
        INPUT_WRAPPER_TIME_SCALE: 'bxf-select__input-wrapper--time-scale',
        ERROR_MESSAGE: 'bxf-select__message--error',
        WARNING_MESSAGE: 'bxf-select__message--warning',
        ERROR_CONTAINER: 'bxf-select__error-container',
        ERROR_CONTAINER_FULL_WIDTH: 'bxf-select__error-container-full-width',
        INPUT_CONTAINER: 'bxf-select__input-container',
        INPUT_CONTAINER_SMALL: 'bxf-select__input-container-small',
        INPUT_CONTAINER_LARGE: 'bxf-select__input-container-large',
        INPUT_CONTAINER_FOCUS: 'bxf-select__input-container--focus',
        INPUT_CONTAINER_KEY_FOCUS: 'bxf-select__input-container--key-focus',
        INPUT_CONTAINER_DISABLED: 'bxf-select__input-container--disabled',
        INPUT_CONTAINER_READONLY: 'bxf-select__input-container--readonly',
        INPUT_CONTAINER_INVALID: 'bxf-select__input-container--invalid',
        INPUT_CONTAINER_ERROR: 'bxf-select__input-container--error',
        INPUT_CONTAINER_WARNING: 'bxf-select__input-container--warning',
        INPUT: 'bxf-select__input',
        INPUT_SMALL: 'bxf-select__input-small',
        INPUT_LARGE: 'bxf-select__input-large',
        INPUT_COMBOBOX: 'bxf-select__input--combobox',
        INPUT_DISABLED: 'bxf-select__input--disabled',
        INPUT_SIMPLE_SELECT_DISABLED: 'bxf-select__input-simple-select--disabled',
        ICON: 'bxf-select__icon',
        ICON_SMALL: 'bxf-select__icon-small',
        ICON_LARGE: 'bxf-select__icon-large',
        INFO_CONTAINER: 'bxf-select__info-container',
        ICON_FOCUS: 'bxf-select__icon--focus',
        DROPDOWN_CONTAINER: 'bxf-select__dropdown-container',
        DROPDOWN_LISTBOX: 'bxf-select__dropdown-listbox',
        DROPDOWN: 'bxf-select__dropdown',
        TYPEAHEAD_CONTAINER: 'bxf-select__typeahead-container',
        OPTION_GROUP_LABEL: 'bxf-select__option-group-label',
        OPTION: 'bxf-select__option',
        OPTION_SINGLE: 'bxf-select__option--single',
        OPTION_COMPACT: 'bxf-select__option--compact',
        OPTION_SPAN: 'bxf-select__option-span',
        OPTION_CHECKBOX: 'bxf-select__option-checkbox',
        OPTION_CHECKBOX_LARGE: 'bxf-select__option-checkbox-large',
        OPTION_CONTAINER: 'bxf-select__option-container',
        PSEUDO_CHECKBOX: 'bxf-select__pseudo-checkbox',
        OPTION_CONTAINER_DEFAULT: 'bxf-select__option-container-default',
        OPTION_CONTAINER_DEFAULT_COMPACT: 'bxf-select__option-container-default--compact',
        OPTION_CONTAINER_DEFAULT_CHECKBOX: 'bxf-select__option-container-default--checkbox',
        OPTION_CONTAINER_DEFAULT_INITIAL: 'bxf-select__option-container-default--initial',
        OPTION_CONTAINER_DISABLED: 'bxf-select__option-container-disabled',
        OPTION_BORDER: 'bxf-select__option-border',
        OPTION_SELECTED: 'bxf-select__option--selected',
        OPTION_LABEL_BOLD: 'bxf-select__option-label-bold',
        LABEL: 'bxf-select__label',
        LABEL_COMPACT: 'bxf-select__label--compact',
        REGULAR: 'regular',
        SMALL: 'small',
        LARGE: 'large',
        LABEL_CONTAINER: 'bxf-select__label-container',
        LABEL_CONTAINER_COMPACT: 'bxf-select__label-container--compact',
        LABEL_CONTAINER_TIME_SCALE: 'bxf-select__label-container--time-scale',
        LABEL_CONTAINER_TIME_SCALE_STACKED: 'bxf-select__label-container--time-scale-stacked',
        LABEL_CONTAINER_LEFT: 'bxf-select__label-container--left',
        LABEL_CONTAINER_LEFT_SMALL: 'bxf-select__label-container--left-small',
        LABEL_CONTAINER_LEFT_LARGE: 'bxf-select__label-container--left-large',
        LABEL_CONTAINER_LEFT_VALIDATION: 'bxf-select__label-container--left-validation',
        LABEL_CONTAINER_LEFT_VALIDATION_SMALL: 'bxf-select__label-container--left-validation-small',
        LABEL_CONTAINER_LEFT_VALIDATION_LARGE: 'bxf-select__label-container--left-validation-large',
        LABEL_ASTERISK: 'bxf-select__label-asterisk',
        LABEL_DISABLED: 'bxf-select__label--disabled',
        LABEL_WITH_INSTRUCTIONAL_TEXT: 'bxf-select__label--instructional-text',
        SEPARATOR: 'bxf-select__separator',
        SEPARATOR_SMALL: 'bxf-select__separator-small',
        SEPARATOR_LARGE: 'bxf-select__separator-large',
        SEPARATOR_CONTAINER: 'bxf-select__separator-container',
        SEPARATOR_FOCUS: 'bxf-select__separator--focus',
        SEPARATOR_KEY_FOCUS: 'bxf-select__separator--key-focus',
        SEPARATOR_ERROR: 'bxf-select__separator--error',
        SEPARATOR_WARNING: 'bxf-select__separator--warning',
        SEPARATOR_HIDDEN: 'bxf-select__separator--hidden',
        ACTION_BUTTON_CONTAINER: 'bxf-select__action-button-container',
        LOADING: 'bxf-select__loading',
        OPTION_GROUP_BORDER: 'bxf-option-group-border',
        INSTRUCTIONAL_TEXT: 'bxf-select__instructional-text',
        TABLE_HEADER_CELL: 'bxf-select__table-header-cell',
        TABLE_CELL: 'bxf-select__table-cell',
        TABLE_ROW: 'bxf-select__table-row',
        TABLE_FOOTER: 'bxf-select__table-footer',
        DROPDOWN_CONTENT: 'bxf-select__dropdown-content',
        TABLE: 'bxf-select__table',
    };
    static SIZES = {
        OPTION_HEIGHT_REGULAR: 32,
        OPTION_HEIGHT_COMPACT: 20,
        TOOLTIP_CONTENT_MAX: 10,
        LOADING_DROPDOWN_HEIGHT: 100,
        PADDING_AND_MARGIN_SIZE: 40,
    };
    static EVENTS = {
        SELECTION_CHANGED: 'selectionChanged',
    };
}

export { BxfSelectConstants as B };
